import { useEffect } from 'react';
import { atom, selector, useRecoilState } from 'recoil';
import CompaniesApi from 'libs/api/admin/companies';
import FiltersApi from '../libs/api/filters';

const api = new CompaniesApi();
const filtersApi = new FiltersApi('');

const defaultState = [];

const shopsState = atom({
  key: 'shops',
  default: defaultState,
});

const filtersState = atom({
  key: 'filtersState',
  default: {
    shopping_centers: [],
    companies: [],
    inactive_companies: [],
    chains: [],
    company_categories: [],
    company_child_categories: [],
    prestige_levels: [],
    tax_frees: [],
    macro_categoris: [],
    product_sheet_models: [],
    products_limits: [],
    all_companies: [],
  },
});

export const getFilters = selector({
  key: 'getFilters',
  get: ({ get }) => {
    return get(filtersState);
  },
});

export const getAllCompanies = selector({
  key: 'getAllCompanies',
  get: ({ get }) => {
    return get(filtersState)?.all_companies.map((i) =>  ({
      id: i.value,
      value: i.value,
      title: `${i.title} (${i?.shopping_center_title || ''})`,
      shopping_center_title: i?.shopping_center_title || '',
    }));
  },
});

export const getShops = selector({
  key: 'getShops',
  get: ({ get }) => {
    return get(filtersState)?.companies.map((i) => ({
      id: i.value,
      value: i.value,
      title: `${i.title}`,
    }));
  },
});

export const getInactiveShops = selector({
  key: 'getInactiveShops',
  get: ({ get }) => {
    return (get(filtersState)?.inactive_companies || []).map((i) => ({
      id: i.value,
      value: i.value,
      title: `${i.title}`,
    }));
  },
});

const useShops = () => {
  const [filtersData, setFiltersData] = useRecoilState(filtersState);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await filtersApi.get('');
        setFiltersData({
          ...data,
          companies: data?.companies?.map((i) => ({
            ...i,
            title: `${i.title} (${i.shopping_center_title})`,
          })),
          inactive_companies: data?.inactive_companies?.map((i) => ({
            ...i,
            title: `${i.title} (${i.shopping_center_title})`,
          })),
        });
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);
  return {
    shops: [],
    filtersData,
  };
};

export default useShops;
